import { format } from "date-fns";
import PinIcon from "@/public/icons/pin.svg";
import { formatInTimeZone } from "date-fns-tz";

type BookingTimeSlotCardProps = {
  slot: string;
  address: string;
  heading: string;
  subHeading: string;
};
export const BookingTimeSlotCard: React.FC<BookingTimeSlotCardProps> = ({
  slot,
  address,
  subHeading,
  heading,
}) => {
  return (
    <div className="flex border border-landing-denim py-3 px-4 mt-6 md:mt-0 rounded-2xl gap-4 h-fit overflow-hidden">
      <div className="flex flex-col items-center gap-[6px] text-landing-denim">
        <p className="text-xs font-bold leading-6 uppercase">{format(new Date(slot), "MMM")}</p>
        <p className="font-semibold text-[40px] leading-5">{format(new Date(slot), "d")}</p>
        <div className="border border-landing-lighterGray p-1 rounded-full px-5 text-sm mt-[6px] font-semibold">
          <p>{formatInTimeZone(new Date(slot), "Europe/London", "HH:mm")}</p>
        </div>
      </div>
      <div className="flex flex-col gap-[6px]">
        <p className="text-base font-bold leading-6 ">{heading}</p>
        <p className="font-normal text-sm leading-4 text-landing-lightGray70 line-clamp-2">
          {subHeading}
        </p>
        <div className=" bg-[linear-gradient(270deg,rgba(243,146,55,0.2)_3.04%,rgba(255,171,0,0.2)_96.96%)]  h-[26px] flex items-center gap-1 px-2 py-1 rounded-[5px] xxs:w-fit ">
          <PinIcon className={`h-[14px] w-[11px] fill-landing-orange`} />
          <p className="font-sans font-semibold text-navy text-xs leading-[18px] line-clamp-1">
            {address}
          </p>
        </div>
      </div>
    </div>
  );
};
